import React, { Component } from 'react'
import Plan from './Plans'

class Plans extends Component {
  render() {
    return (
      <Plan {...this.props} ref='plan'/>
    )
  }
}

export default Plans



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/index.js